import DataFooterButtons from '@/features/DataHub/components/ExportDrawer/DataFooterButtons';
import DefaultFooterButtons from '@/features/DataHub/components/ExportDrawer/DefaultFooterButtons';
import ImageFooterButtons from '@/features/DataHub/components/ExportDrawer/ImageFooterButtons';
import {
  useExportPreview,
  useExportSettings
} from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

const FooterButtons = () => {
  const { exportSettings } = useExportSettings();
  const { previewOptionId } = useExportPreview();

  const hasFormatSelected = previewOptionId !== null || Boolean(exportSettings.exportSubType);

  if (!hasFormatSelected) {
    return <DefaultFooterButtons />;
  }

  if (exportSettings.exportType === ExportTypes.DATA) {
    return <DataFooterButtons />;
  }

  return <ImageFooterButtons />;
};

export default FooterButtons;
